import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import './App.css';

import NotFound from './containers/NotFound';
import Meditation from './containers/Meditation';

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/meditation">
          <Meditation />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
